import React, {useState} from 'react';
import styled from 'styled-components';

import Row from "./../../../common/components/Row.js";
import Col from "./../../../common/components/Col.js";
import Card from "./../../../common/components/Card.js";
import Button from "./../../../common/components/Button.js";
import Typo from "./../../../common/components/Typo.js";
import Input from "./../../../common/components/Input.js";

const Error = styled.div.withConfig({displayName:'-Error'})`
  height: 30px;
  color: red;
`;
const Cta = styled.span`
  cursor: pointer;
`;

const FormRegistration = ({onConfirm, error}) => {
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [givenName, setGivenName] = useState('');
  const [familyName, setFamilyName] = useState('');


  return (

    <Card>
      <Typo variant="h1">Registration</Typo><br/>
      <>Enter your credentials to register.</>

      <Row>
        <Col widthmd="12">
          <Input
            label={"Email"}
            name="email"
            type="email"
            width="100%"
            value={email}
            onChange={(val) => setEmail(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Given Name"}
            name="givenName"
            type="text"
            width="100%"
            value={givenName}
            onChange={(val) => setGivenName(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Family Name"}
            name="familyName"
            type="text"
            width="100%"
            value={familyName}
            onChange={(val) => setFamilyName(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Password"}
            name="password1"
            type="password"
            width="100%"
            value={password1}
            onChange={(val) => setPassword1(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Repeat password"}
            name="password2"
            type="password"
            width="100%"
            value={password2}
            onChange={(val) => setPassword2(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Button onClick={() => onConfirm({
            action: "registration",
            params: {
              email: email,
              password1: password1,
              password2: password2,
              givenName: givenName,
              familyName: familyName,
              locale: "it_IT"
            }
          })}>Sign up</Button>
        </Col>
        <Col widthmd="12">
          <Error>
            <br/>{error}<br/>
          </Error>
        </Col>
        <Col widthmd="12">
          Do you already have an account? <Cta onClick={() => onConfirm({
            action: "navigate",
            params: {
              page: "login"
            }
          })}>Sign in</Cta>.
        </Col>
      </Row>
    </Card>
  )
}

export default FormRegistration;
